/**
 *
 *   Shopify Analytics
 *       - Send the Analytics
 *
 **/
"use client";

import { CustomerContext } from "@/context/customer";
import { AnalyticTools } from "@/libraries/analytics";
import { useSession } from "next-auth/react";
import { useLocale } from "next-intl";
import { usePathname } from "next/navigation";
import { useContext, useEffect } from "react";

/**
 *
 *  Analytics
 *       - The Default Script, Analytics send a Page View event on each page load
 *       - Follows Shopify recommended implementation pattern
 *
 *   Params:
 *       payload:        (Object) The payload data to pass to Shopify Analytics
 *
 **/
export default function CustomAnalytics({ payload = {} }) {
	// Get session data
	const { data: session } = useSession();

	// Get the Customers context
	const { Customer } = useContext(CustomerContext);

	// Get path and locale
	const pathname = usePathname();
	const locale = useLocale();

	// Initialize third-party analytics once
	useEffect(() => {
		if (session) {
			// Initialize Facebook and other analytics with customer data if the customer is logged in
			if (Customer && typeof Customer.get === "function") {
				Customer.get(customer => AnalyticTools.init(customer));
			} else {
				AnalyticTools.init(null); // Initialize with no customer data
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [session]);

	// Send page view on route changes
	useEffect(() => {
		if (session) {
			// Send page view to other analytics tools
			AnalyticTools.pageView();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname, locale, session]);
}

//Export Helper Functions
export { AnalyticTools };
